<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div style="height: auto !important; max-height: 600px !important">
  <div [hidden]="!isAddDocForDocType">
    <app-folder-stucture [data]="'DOCUMENTFORHOME'"
      (valueChange)="changeInFolderStructureChild($event)"></app-folder-stucture>
  </div>
  <div [hidden]="!isShowAddPanel">
    <div class="row">
      <div class="col-md-12">
        <span><b>Selected Folder : </b><span>{{ selectedFolderForCreateDoc.folderName }}</span>&nbsp;&nbsp;
          <span style="cursor: pointer; text-decoration: underline; color: blue" (click)="selectDiffFolderFunc()"
            (keydown.enter)="selectDiffFolderFunc()">Select
            Different Folder</span>
        </span>
      </div>
    </div>
    <div>
      <div class="row" [hidden]="!isShowAddDocForDocType">
        <div class="col-md-4" style="
                height: 450px;
                border: 1px solid darkgray;
                right: 5px;
                left: 5px;
              ">
          <div *ngIf="uploadedFiles.length > 1">
            <i>Note : Please note that the information provided in the Document Details section will be applicable for
              all the uploaded document.</i>
          </div>
          <!-- Add this where you want to show the progress bar -->
          <div *ngIf="uploadProgress !== null" class="upload-progress-container">
            <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
            <div class="progress-text">Uploading... {{ uploadProgress }}%</div>
          </div>
          <div style="margin-top: 15%; overflow-y: auto;" class="button-continer">
            <button class="uploadButton" (click)="openFileDialog()" style="border-radius: 5px;">
              Choose File</button>
            <input type="file" #fileInput multiple style="display:none;" (change)="onFileSelected($event)">
            <div style="overflow-y: auto; gap: 8px; height: 300px;" cdkDropList (cdkDropListDropped)="drop($event)">

              <div *ngFor="let file of uploadedFiles; let i = index" cdkDrag
                style="display: flex; align-items: center; background: #f1f1f1; padding: 6px 8px; border-radius: 4px; cursor: move; margin-bottom: 6px; border: 1px solid #ccc;">

                <i class="fa fa-bars" style="color: gray; margin-right: 8px;" title="Drag to reorder"></i>

                <span style="flex-grow: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{file}}
                </span>

                <i class="fa fa-close" style="color:red;cursor:pointer; margin-left: 8px;" (click)="removeFile(file,i)"
                  (keydown.enter)="removeFile(file,i)"></i>
              </div>

            </div>
          </div>

        </div>
        <div class="col-md-8" style="
                height: 450px;
                border: 1px solid darkgray;
                right: 5px;
                left: 5px;
                overflow-y: scroll;
              ">
          <div class="row" style="margin-left: 0px">
            <div class="row">
            </div>
            <div class="row">
              <div class="col-md-3"
                *ngIf="isVersionManuallyForDocType || documentDataForDocBulkUpload.documentId != null">
                <div><label for="email ">Version</label><span *ngIf="isVersionManuallyForDocType"
                    class="mandatory-symbol">*</span></div>
                <input id="versionForDocType" class="input-filed-continers" type="number"
                  [(ngModel)]="documentDataForDocBulkUpload.version" [disabled]="
                          documentDataForDocBulkUpload.documentId != null &&
                          isVersionManuallyForDocType == false 
                        " (keypress)="validateVersion($event)" />
                <span id="versionForDocType-required-msg">Please enter a document version</span>
              </div>
              <div class="col-md-6">
                <div>
                  <label for="email">Document Type</label><span class="mandatory-symbol">*</span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedDocumentTypeForDoc"
                  (closed)="docTypeForDocSearchText=''" (click)="focusSearch('focus-doc-type-for-doc-search')"
                  id="documentType" (keydown.enter)="focusSearch('focus-doc-type-for-doc-search')">
                  <input type="search" id="focus-doc-type-for-doc-search" class="dropdownsearchstyle"
                    [(ngModel)]="docTypeForDocSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="ondocumentTypeForDocSelect($event,null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of documentTypeDropdown | assessmentSearch : docTypeForDocSearchText"
                    [value]="item.valueExp" (onSelectionChange)="ondocumentTypeForDocSelect($event,item.valueExp)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
                <span id="documentType-required-msg">Please enter a document type</span>
              </div>

            </div>

            <div class="row">
              <div class="col-md-6">
                <div>
                  <label for="email">Effective From Date:</label>
                </div>
                <div>
                  <input type="text" class="form-control data-picker-continer" bsDatepicker
                    [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                    [(ngModel)]="documentDataForDocBulkUpload.effectiveDate" (ngModelChange)="
                          selectExpValue(
                            documentDataForDocBulkUpload.effectiveDate
                          )
                        " />
                </div>
              </div>
              <div class="col-md-6" *ngIf="isShowExpDate">
                <div><label for="email">Expiration Date:</label></div>
                <div>
                  <input type="text" class="form-control data-picker-continer" bsDatepicker
                    [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                    [(ngModel)]="documentDataForDocBulkUpload.expirationDate" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div>
                  <label for="email ">Document Description</label>
                  <span class="mandatory-symbol">*</span>
                </div>
                <textarea id="description" rows="4" class="input-filed-textarea" type="text" [(ngModel)]="
                        documentDataForDocBulkUpload.documentDescription
                      "></textarea>
                <span id="description-required-msg" style="display: block">Please enter description</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div>
                  <label for="email ">Revision History</label><span class="mandatory-symbol">*</span>
                </div>
                <div style="margin-bottom: 1%">
                  <st-editor [(ngModel)]="documentDataForDocBulkUpload.revisionHistory" [config]="config"
                    id="revisionHistory" (paste)="onPaste($event)"></st-editor>
                  <span id="revisionHistory-required-msg" style="display: block">Please enter revision history</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" *ngIf="isShowAssociatedDocumentField">
                <div>
                  <label for="email ">Link to Parent Document</label>
                </div>
                <div class="row row-search-container" style="margin-bottom: 1%">
                  <div class="col-md-6" style="padding-left: 5px">
                    <input id="userName" class="form-control" type="text" placeholder="Search" [(ngModel)]="
                            documentDataForDocBulkUpload.associatedDocumentName" (click)="searchDocumentFunction()" />

                  </div>
                  <span class="col-md-6" *ngIf="
                          documentDataForDocBulkUpload.associatedFolderPath !=
                          null
                        "><b>Path :</b>
                    {{
                    documentDataForDocBulkUpload.associatedFolderPath
                    }},&nbsp; <b>Status : </b>{{ documentDataForDocBulkUpload.associatedStatus }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6" *ngIf="isShowUserBelongsToField">
                <div>
                  <label for="email ">Belongs To User</label><span class="mandatory-symbol">*</span>
                </div>
                <div class="row-search-container">
                  <input id="belongsToUser" class="form-control" type="text" placeholder="Search"
                    [(ngModel)]="documentDataForDocBulkUpload.belongsUserName"
                    (click)="searchUserFunction('Document')" />
                </div>
                <span id="belongsToUser-required-msg">Please enter belongs to user</span>
              </div>
              <div class="col-md-6" *ngIf="isShowCrFields">
                <div>
                  <label for="email">CR</label><span class="mandatory-symbol" *ngIf="isCrFeildIsMandatory">*</span>
                </div>
                <div class="row-search-container">
                  <input id="cr" class="form-control" type="text" placeholder="Search"
                    [(ngModel)]="documentDataForDocBulkUpload.crId" (click)="searchCrFunction('Document')" />
                </div>
                <span id="cr-required-msg" *ngIf="isCrFeildIsMandatory">Please select CR</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4" *ngIf="isShowIsBlindedFlag">
                <div><label for="email">Is Blinded</label></div>
                <mat-slide-toggle color="primary" [(ngModel)]="documentDataForDocBulkUpload.isBlinded1"
                  [disabled]="!iSBlindTheDoc">
                  <span class="active-inActive-container" *ngIf="documentDataForDocBulkUpload.isBlinded1 == true"
                    [ngStyle]="
                          documentDataForDocBulkUpload.isBlinded1 == true
                            ? { color: 'green' }
                            : { color: '' }
                        ">Blinded</span>
                  <span *ngIf="documentDataForDocBulkUpload.isBlinded1 == false" [ngStyle]="
                          documentDataForDocBulkUpload.isBlinded1 == false
                            ? { color: 'red' }
                            : { color: '' }
                        ">Not Blinded</span>
                </mat-slide-toggle>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
  <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
    (click)="addDocForBulkUploadFunc()" (keydown.enter)="addDocForBulkUploadFunc()" *ngIf="isShowAddPanel">
    <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
    <span class="reload_text text-white">Add</span>
  </div>

  <button mat-stroked-button class="cancelButton" (click)="cancelBulkUploadFunc()">
    <i class="fa fa-close"></i> Cancel
  </button>
</div>

<ng-template #searchCr>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelCrFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Search CR</label>
    <label for="pop" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div id="filed-container" class="form-continer" style="height: 600px">
    <div class="row">
      <div class="col-md-8 group-dropdown-container">
        <label for="email">Group</label><span class="mandatory-symbol">*</span>
        <div class="col-sm-6 group-dropdown-align">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedCrGroup" (closed)="crGroupsSearchText=''"
            (click)="focusSearch('focus-cr-group-search')" (keydown.enter)="focusSearch('focus-cr-group-search')"
            id="groupSearch">
            <input type="search" id="focus-cr-group-search" class="dropdownsearchstyle" [(ngModel)]="crGroupsSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onGroupValueSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : crGroupsSearchText"
              [value]="item.valueExp" (onSelectionChange)="onGroupValueSelect($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
          <span id="groupSearch-required-msg">Please choose group to select</span>
        </div>
      </div>
    </div>
    <div class="row text-center">
      <div class="group-dropdown-align">
        <div class="search-button-continer">
          <button mat-stroked-button class="searchButton searchButton1" (click)="seachCrForDocumentsFunc()">
            <i class="fa-solid fa-magnifying-glass"></i> Search
          </button>
          <button mat-stroked-button class="cancelButton resetButton" (click)="gridResetFunction()">
            <i class="fa fa-repeat"></i> Reset
          </button>
        </div>
      </div>
    </div>
    <div class="table-container" *ngIf="isShowSearchedCrGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center"></th>
        <th>
          <span>Cr ID</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Description</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Status</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Initiator</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Owner</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>QA</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Business Area</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th id="menu" class="sticky-col first-col"></th>
        <tr class="data-row-container" *ngFor="let cr of searchedCrList; let idx = index">
          <td style="min-width: 80px; text-align: center">
            <div style="display: flex">
              <div [ngClass]="
                    cr.searchCrChildCheckBoxs ? 'static_icon' : 'hover-menu-icons'
                  ">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px">
                <input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2" [checked]="cr.searchCrChildCheckBoxs"
                  (change)="searchCrChildCheckBoxChecked($event, cr, idx)" />
              </div>
            </div>
          </td>
          <td class="row-data">{{ cr.crId }}</td>
          <td class="row-data">{{ cr.shortDescription }}</td>
          <td class="row-data">{{ cr.status }}</td>
          <td class="row-data">{{ cr.initiatedByUserName }}</td>
          <td class="row-data">{{ cr.ownerUserName }}</td>
          <td class="row-data">{{ cr.qaUserName }}</td>
          <td class="row-data">{{ cr.coreBusinessAreaName }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addCrFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelCrFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #infoPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="okInfo()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Warning</label>
    <label for="title" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px">
    <div class="row">
      <div class="col-md-12">
        {{warningMsg}}
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="okInfo()"
        (keydown.enter)="okInfo()">
        <span class="reload_text text-white">OK</span>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #searchUser>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchUserFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="popup" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="form-continer filed-container">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name"
          [(ngModel)]="searchByUserName" />
        <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter First Name"
          [(ngModel)]="searchByFirstName" />
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Last Name"
          [(ngModel)]="searchByLastName" />
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode"
          (closed)="designationSearchText=''" (click)="focusSearch('focus-designation-search')"
          (keydown.enter)="focusSearch('focus-designation-search')">
          <input type="search" id="focus-designation-search" class="dropdownsearchstyle"
            [(ngModel)]="designationSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDesignationCodeSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of designationCodeDropdown | assessmentSearch : designationSearchText"
            [value]="item.valueExp" (onSelectionChange)="onDesignationCodeSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')"
          (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDepartmentCodeSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : departmentSearchText"
            [value]="item.valueExp" (onSelectionChange)="onDepartmentCodeSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchUserGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchUserGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center">
          <div style="display: flex">
            <div>
              <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px">
              <input type="checkbox" style="zoom: 1.2" [checked]="searchUserParentCheckBox"
                (change)="searchUserDataGridParentCheckBoxChecked($event)" />
            </div>
          </div>
        </th>
        <th>
          <span>User Name</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>First Name</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Last Name</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>User Full Name</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Designation</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Department</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>EmailAddress</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Manager Name</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th class="sticky-col first-col menu"></th>
        <tr class="data-row-container" *ngFor="
              let listOfUsersVwDetails of getOneQmsUsersVwDetailsTableData;
              let idx = index
            ">
          <td style="min-width: 80px; text-align: center">
            <div style="display: flex">
              <div [ngClass]="
                    listOfUsersVwDetails.searchUserChildCheckBoxs
                      ? 'static_icon'
                      : 'hover-menu-icons'
                  ">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px">
                <input id="selectedCheckBox" type="checkbox" style="zoom: 1.2"
                  [checked]="listOfUsersVwDetails.searchUserChildCheckBoxs" (change)="
                      searchUserChildCheckBoxChecked(
                        $event,
                        listOfUsersVwDetails,
                        idx
                      )
                    " />
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersVwDetails.userName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.firstName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.lastName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.userFullname }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.designation }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.department }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.emailAddress }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.managerName }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addUserNameFunction()"
      (keydown.enter)="addUserNameFunction()">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchUserFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #resultDisplayPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelConfirmationFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Documents - <b>Selected Folder : </b><span>{{
        selectedFolderForCreateDoc.folderName }}</span></label>
    <label for="popup" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="form-continer filed-container" style="height: 600px">
    <div class="row">
      <div class="col-md-4">
        <div class="mb-3 contents" *ngFor="let document of resultList,let i=index;" style="cursor: pointer;"
          [class.active]="document.documentId ==selectedDocId"
          (click)="getDocumentRelatedDetails(document.documentId,false)"
          (keydown.enter)="getDocumentRelatedDetails(document.documentId,false)">
          <div class="d-flex gap-2">

            <p class="training_text">

              <span *ngIf="document.documentNo != null"> {{document.documentName}} ({{document.documentNo}})
                <img alt="yes" src="../../../assets/img/accessSymbol.png" style="height: 20px;width: 20px;"></span>
              <span *ngIf="document.documentNo == null">
                {{document.result}}
                <img alt="no" src="../../../assets/img/noAcessSymbol.png" style="height: 20px;width: 20px;">
              </span>
            </p>
          </div>

        </div>

      </div>
      <div class="col-md-8">
        <div class="row" *ngIf="documentDataForDocBulkUpload.documentId == undefined">
          Document saving has errors.
        </div>
        <div class="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom"
          *ngIf="documentDataForDocBulkUpload.documentId">
          <div style="font-size: 16px;">
            <strong>Document Status: </strong>
            <span [ngClass]="documentDataForDocBulkUpload.status == 'Published' ? 'text-success' : 'text-primary'">
              {{ documentDataForDocBulkUpload.status || 'Draft' }}
            </span>
          </div>

          <div class="button-continer d-flex gap-3">
            <div *ngIf="documentDataForDocBulkUpload.checkoutFlag =='Y'" style="width: fit-content; cursor: pointer;"
              class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="updateDocumentDetails()" (keydown.enter)="updateDocumentDetails()">
              <span class="reload_text text-white">Save</span>
            </div>
            <div *ngIf="documentDataForDocBulkUpload.checkoutFlag =='Y'" style="width: fit-content;float: right;"
              class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="saveFlexifieldData()" (keydown.enter)="saveFlexifieldData()">
              <span class="reload_text text-white">Save Additional Details</span>
            </div>
            <ng-container *ngFor="let button of buttonLabels">
              <div style="width: fit-content; cursor: pointer; background-color: #005c8a;"
                class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="dynamicButtonClick(button)" (keydown.enter)="dynamicButtonClick(button)">
                <span class="reload_text text-white">{{ button }}</span>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="tab" *ngIf="documentDataForDocBulkUpload.documentId">
          <mat-tab-group selectedIndex="0" mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4"
            animationDuration="0ms" (selectedTabChange)="onTabChanged1($event)" [(selectedIndex)]="selectedTabIndex">
            <mat-tab label="Document Details">
              <ng-template mat-tab-label>
                <span> <b>Document Details </b></span>
              </ng-template>
              <div class="row" style="margin-left: 0px">
                <div class="row">
                  <div class="col-md-6">
                    <div>
                      <label for="email ">Document Name</label><span class="mandatory-symbol">*</span>
                    </div>
                    <input class="input-filed-continers" type="text"
                      [(ngModel)]="documentDataForDocBulkUpload.documentName" />

                  </div>

                  <div class="col-md-4">
                    <div><label for="email ">Document No.</label></div>
                    <input class="input-filed-continers" type="text"
                      [(ngModel)]="documentDataForDocBulkUpload.documentNo" disabled />

                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3"
                    *ngIf="isVersionManuallyForDocType || documentDataForDocBulkUpload.documentId != null">
                    <div><label for="email ">Version</label><span *ngIf="isVersionManuallyForDocType"
                        class="mandatory-symbol">*</span></div>
                    <input class="input-filed-continers" type="number"
                      [(ngModel)]="documentDataForDocBulkUpload.version" [disabled]="
                                    documentDataForDocBulkUpload.documentId != null &&
                                    isVersionManuallyForDocType == false 
                                  " (keypress)="validateVersion($event)" />

                  </div>
                  <div class="col-md-6">
                    <div>
                      <label for="email">Document Type</label><span class="mandatory-symbol">*</span>
                    </div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="selectedDocumentTypeForDoc"
                      (closed)="docTypeForDocSearchText=''" (click)="focusSearch('focus-doc-type-for-doc-search')"
                      disabled (keydown.enter)="focusSearch('focus-doc-type-for-doc-search')">
                      <input type="search" id="focus-doc-type-search" class="dropdownsearchstyle"
                        [(ngModel)]="docTypeForDocSearchText" matInput placeholder="search">
                      <mat-option class="unselectStyle" [value]="null"
                        (onSelectionChange)="ondocumentTypeForDocSelect($event,null)">Un-select</mat-option>
                      <mat-option *ngFor="let item of documentTypeDropdown | assessmentSearch : docTypeForDocSearchText"
                        [value]="item.valueExp" (onSelectionChange)="ondocumentTypeForDocSelect($event,item.valueExp)">
                        {{ item.displayExp }}
                      </mat-option>
                    </mat-select>

                  </div>

                </div>

                <div class="row">
  <div class="col-md-6">
    <div>
      <label for="email">Effective From Date:</label>
    </div>
    <div>
      <input type="text" class="form-control data-picker-continer" bsDatepicker
        [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
        [(ngModel)]="documentDataForDocBulkUpload.effectiveDate" (ngModelChange)="
                    selectExpValue(
                      documentDataForDocBulkUpload.effectiveDate
                    )
                  " />
    </div>
  </div>
  
  <div class="col-md-6" *ngIf="isShowExpDate">
    <div><label for="email">Expiration Date:</label></div>
    <div>
      <input type="text" class="form-control data-picker-continer" bsDatepicker
        [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
        [(ngModel)]="documentDataForDocBulkUpload.expirationDate" />
    </div>
  </div>
</div>
                <div class="row">
                  <div class="col-md-12">
                    <div>
                      <label for="email ">Document Description</label>
                    </div>
                    <textarea rows="4" class="input-filed-textarea" type="text" [(ngModel)]="
                                  documentDataForDocBulkUpload.documentDescription
                                "></textarea>

                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div>
                      <label for="email ">Revision History</label><span class="mandatory-symbol">*</span>
                    </div>
                    <div style="margin-bottom: 1%">
                      <st-editor [(ngModel)]="documentDataForDocBulkUpload.revisionHistory" [config]="config"
                        id="revisionHistory"></st-editor>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12" *ngIf="isShowAssociatedDocumentField">
                    <div>
                      <label for="email ">Link to Parent Document</label>
                    </div>
                    <div class="row row-search-container" style="margin-bottom: 1%">
                      <div class="col-md-6" style="padding-left: 5px">
                        <input class="form-control" type="text" placeholder="Search" [(ngModel)]="
                                      documentDataForDocBulkUpload.associatedDocumentName"
                          (click)="searchDocumentFunction()" />

                      </div>
                      <span class="col-md-6" *ngIf="
                                    documentDataForDocBulkUpload.associatedFolderPath !=
                                    null
                                  "><b>Path :</b>
                        {{
                        documentDataForDocBulkUpload.associatedFolderPath
                        }},&nbsp; <b>Status : </b>{{ documentDataForDocBulkUpload.associatedStatus }}</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6" *ngIf="isShowUserBelongsToField">
                    <div>
                      <label for="email ">Belongs To User</label><span class="mandatory-symbol">*</span>
                    </div>
                    <div class="row-search-container">
                      <input class="form-control" type="text" placeholder="Search"
                        [(ngModel)]="documentDataForDocBulkUpload.belongsUserName"
                        (click)="searchUserFunction('Document')" />
                    </div>

                  </div>
                  <div class="col-md-6" *ngIf="isShowCrFields">
                    <div>
                      <label for="email">CR</label><span class="mandatory-symbol" *ngIf="isCrFeildIsMandatory">*</span>
                    </div>
                    <div class="row-search-container">
                      <input class="form-control" type="text" placeholder="Search"
                        [(ngModel)]="documentDataForDocBulkUpload.crId" (click)="searchCrFunction('Document')" />
                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4" *ngIf="isShowIsBlindedFlag">
                    <div><label for="email">Is Blinded</label></div>
                    <mat-slide-toggle color="primary" [(ngModel)]="documentDataForDocBulkUpload.isBlinded1">
                      <span class="active-inActive-container" *ngIf="documentDataForDocBulkUpload.isBlinded1 == true"
                        [ngStyle]="
                                    documentDataForDocBulkUpload.isBlinded1 == true
                                      ? { color: 'green' }
                                      : { color: '' }
                                  ">Blinded</span>
                      <span *ngIf="documentDataForDocBulkUpload.isBlinded1 == false" [ngStyle]="
                                    documentDataForDocBulkUpload.isBlinded1 == false
                                      ? { color: 'red' }
                                      : { color: '' }
                                  ">Not Blinded</span>
                    </mat-slide-toggle>
                  </div>

                </div>
              </div>
            </mat-tab>
            <mat-tab *ngIf="isShowFlexifieldBlock">
              <ng-template mat-tab-label> Additional Details </ng-template>
              <div class="row">
                <div class="col-md-5"></div>
                <div class="col-md-6" style="float:right;">
                  <mat-checkbox *ngIf="isShowCheckBox" [(ngModel)]="IsApplicableAdditionalDetail"
                    [checked]="IsApplicableAdditionalDetail">Applicable To All Documents</mat-checkbox>
                </div>
                <div class="col-md-1">

                </div>
                <div class="col-md-12">
                  <div class="row" *ngFor="let flexifield of flexiFieldsList; let i = index"
                    style="margin-bottom: 10px">
                    <div class="col-md-3">
                      <label for="name">{{ flexifield.fieldName }}</label><span *ngIf="flexifield.isMandatory == 'Y'"
                        class="mandatory-symbol">*</span>
                    </div>

                    <div class="col-md-9" *ngIf="
                                  flexifield.fieldType == 'Text Field' &&
                                  flexifield.fieldDatatype != 'Date' &&
                                  flexifield.fieldDatatype != 'Datetime'
                                ">
                      <input attr.id="flexifield{{ i }}" class="input-filed-continers" type="text"
                        [(ngModel)]="flexifield.fieldDefaultValue" />
                      <span id="flexifield{{ i }}-required-msg">Please enter a {{ flexifield.fieldName }}</span>
                    </div>

                    <div class="col-md-9" *ngIf="
                                  flexifield.fieldType == 'Text Field' &&
                                  flexifield.fieldDatatype == 'Date'
                                ">
                      <input attr.id="flexifield{{ i }}" type="text" class="form-control data-picker-continer"
                        bsDatepicker [bsConfig]="$getDateConfig(flexifield)" [dateCustomClasses]="dateCustomClasses"
                        [(ngModel)]="flexifield.fieldDefaultValue" />
                      <span id="flexifield{{ i }}-required-msg">Please enter a {{ flexifield.fieldName }}</span>
                    </div>

                    <div class="col-md-9" *ngIf="
                                  flexifield.fieldType == 'Text Field' &&
                                  flexifield.fieldDatatype == 'Datetime'
                                ">
                      <input attr.id="flexifield{{ i }}" type="text" class="form-control datatime-picker-continer"
                        placement="top" bsDatepicker #datePicker="bsDatepicker"
                        [bsConfig]="$getDateTimeConfig(flexifield)" [dateCustomClasses]="dateCustomClasses"
                        [(ngModel)]="flexifield.fieldDefaultValue"
                        (ngModelChange)="flexifield.fieldDefaultValue != null ? onDateChange(datePicker) : ''" />
                      <span id="flexifield{{ i }}-required-msg">Please enter a {{ flexifield.fieldName }}</span>
                    </div>

                    <div class="col-md-9" *ngIf="flexifield.fieldType == 'Large Text'">
                      <textarea attr.id="flexifield{{ i }}" type="text" class="input-filed-textarea" rows="4"
                        [(ngModel)]="flexifield.fieldDefaultValue"></textarea>
                      <span id="flexifield{{ i }}-required-msg">Please enter a {{ flexifield.fieldName }}</span>
                    </div>

                    <div class="col-md-9" *ngIf="flexifield.fieldType == 'Drop Down'">
                      <mat-select matInput placeholder="Select" [(ngModel)]="flexifield.fieldDefaultValue"
                        (closed)="flexifieldSearchTxt=''" (click)="focusmethod('focusSearch')"
                        [disabled]="flexifield.isEditable == 'N'">
                        <input type="search" attr.id="flexifield{{i}}" class="dropdownsearchstyle"
                          [(ngModel)]="flexifieldSearchTxt" matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null"
                          (onSelectionChange)="onFlexifieldSelect(flexifield,null);">Un-select</mat-option>
                        <mat-option *ngFor="let item of flexifield.dropdowns| assessmentSearch :flexifieldSearchTxt"
                          (onSelectionChange)="onFlexifieldSelect(flexifield,item)" [value]="item.valueExp">
                          {{ item.displayExp }}
                        </mat-option>
                      </mat-select>
                      <span id="flexifield{{ i }}-required-msg">Please enter a {{ flexifield.fieldName }}</span>
                    </div>

                    <div class="col-md-9" *ngIf="flexifield.fieldType == 'Multiselect Drop Down'">
                      <mat-select placeholder="Select" multiple [(ngModel)]="flexifield.selectedFlexifieldValue"
                        [disabled]="flexifield.isEditable == 'N'" attr.id="flexifield{{ i }}">

                        <div
                          style="position: sticky; top: 0; background: white; z-index: 2; border-bottom: 1px solid #ccc;">
                          <mat-checkbox
                            [checked]="flexifield.selectedFlexifieldValue?.length === flexifield.dropdowns?.length && flexifield.dropdowns?.length > 0"
                            [indeterminate]="flexifield.selectedFlexifieldValue?.length > 0 && flexifield.selectedFlexifieldValue?.length < flexifield.dropdowns?.length"
                            (change)="toggleSelectAllFlexifield($event, flexifield)">
                            Select All
                          </mat-checkbox>
                        </div>

                        <mat-option *ngFor="let item of flexifield.dropdowns" [value]="item.valueExp">
                          {{ item.displayExp }}
                        </mat-option>

                      </mat-select>
                      <span id="flexifield{{ i }}-required-msg"
                        style="display: none; color: red; font-size: 12px; margin-top: 5px;">
                        Please select a {{ flexifield.fieldName }}
                      </span>
                    </div>

                    <div class="col-md-9" *ngIf="
                                  flexifield.fieldType == 'Vertical Radio Button' ||
                                  flexifield.fieldType == 'Horizontal Radio Button'
                                ">
                      <mat-radio-group attr.id="flexifield{{ i }}" [(ngModel)]="flexifield.fieldDefaultValue" [ngStyle]="
                                    flexifield.fieldType == 'Vertical Radio Button'
                                      ? {
                                          display: 'flex',
                                          'flex-direction': 'column'
                                        }
                                      : { display: 'inline-flex' }
                                  ">
                        <mat-radio-button *ngFor="let val of flexifield.dropDownValues" [value]="val">{{ val
                          }}</mat-radio-button>
                      </mat-radio-group>
                      <span id="flexifield{{ i }}-required-msg">Please enter a {{ flexifield.fieldName }}</span>
                    </div>

                    <div class="col-md-9" attr.id="flexifield{{ i }}" *ngIf="
                                  flexifield.fieldType ==
                                    'Vertical Checkbox Button' ||
                                  flexifield.fieldType == 'Horizontal Checkbox Button'
                                ">
                      <section *ngFor="let val of flexifield.dropDownValues" [ngStyle]="
                                    flexifield.fieldType == 'Vertical Checkbox Button'
                                      ? {
                                          display: 'flex',
                                          'flex-direction': 'column'
                                        }
                                      : { display: 'inline-flex' }
                                  ">
                        <mat-checkbox (change)="
                                      checkBoxChecked(flexifield, $event, val)
                                    " [checked]="
                                      flexifield.checkedCheckBoxValue.indexOf(val) !=
                                      -1
                                    ">{{ val }}</mat-checkbox>
                      </section>
                      <span id="flexifield{{ i }}-required-msg">Please enter a {{ flexifield.fieldName }}</span>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </mat-tab>
            <mat-tab *ngIf="taskStagesList.length > 0">
              <ng-template mat-tab-label>
                <span *ngFor="let stage of taskStagesList; let index = index">{{ stage.stageName
                  }}<span *ngIf="index != taskStagesList.length - 1">/</span></span>
              </ng-template>

              <div class="row">
                <app-stage-user [data]="documentDataForDocBulkUpload"></app-stage-user>
              </div>

            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>

  </div>
  <div class="button-continer btn-align" mat-dialog-actions>

    <button mat-stroked-button class="cancelButton" (click)="cancelConfirmationFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #searchDocument>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchDocumentFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="popups" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="form-continer filed-container">
    <app-folder-stucture [data]="'DOCUMENT'"
      (valueChange)="changeInFolderStructureChildForSearch($event)"></app-folder-stucture>

  </div>

  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addDocumentFunction()"
      (keydown.enter)="addDocumentFunction()">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchDocumentFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #confirmWithReasonPopup>
  <h2 mat-dialog-title>{{ buttonLabel }}</h2>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <div style="margin: 15px 15px">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div>
            <label for="reason">Comments</label><span class="mandatory-symbol">*</span>
          </div>
          <textarea id="reason" rows="4" class="input-filed-textarea" type="text" [(ngModel)]="reason"></textarea>
          <span id="reason-required-msg" style="display: none; color: red;">Please enter comments</span>
        </div>
      </div>

      <div class="row mt-3" *ngIf="isShowCheckBox">
        <div class="col-md-12">
          <mat-checkbox [(ngModel)]="isApplyToAllCheckIn">
            Apply {{buttonLabel}} to all uploaded documents
          </mat-checkbox>
        </div>
      </div>
    </div>

    <div class="button-continer d-flex justify-content-end gap-3 mt-4 btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="confirmWithReasonFunc()">
        {{ buttonLabel }}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelConfirmFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #publishPopup>
  <h2 mat-dialog-title>{{ buttonLabel }}</h2>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <div style="margin: 15px 15px">
    <div class="form-continer">

      <div class="row" *ngIf="getOneQmsUsersTrainingsRepVwDetails.length > 0">
        <p>Please note, this document is associated with a training. The current completion rate of the training is
          shown below.</p>
        <div class="table-container">
          <div class="table-header1">
            <div class="table-cell-th1" style="min-width: 200px;">Training Name</div>
            <div class="table-cell-th1" style="min-width: 60px;">Total</div>
            <div class="table-cell-th1" style="min-width: 80px;">Pending</div>
            <div class="table-cell-th1" style="min-width: 80px;">Completed</div>
            <div class="table-cell-th1" style="min-width: 70px;">Pass %</div>
          </div>
          <div class="table-row1" *ngFor="let listOfUsersData of pagedItemsMain; let idx = index;">
            <div class="table-cell1 nameAlign" style="min-width: 200px;">{{listOfUsersData.trainingName}}</div>
            <div class="table-cell1 valueAlign" style="min-width:60px;">{{listOfUsersData.total}}</div>
            <div class="table-cell1 valueAlign" style="min-width: 80px;">{{listOfUsersData.pending}}</div>
            <div class="table-cell1 valueAlign" style="min-width: 80px;">{{listOfUsersData.completed}}</div>
            <div class="table-cell1 valueAlignC" style="min-width:70px;">{{(listOfUsersData.completed /
              listOfUsersData.total * 100).toFixed(1)}}%</div>
          </div>
        </div>
      </div>
      <br *ngIf="getOneQmsUsersTrainingsRepVwDetails.length > 0">

      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-4">
              <label for="effectiveDate">Effective Date</label><span class="mandatory-symbol">*</span>
            </div>
            <div class="col-md-8">
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="documentDataForDocBulkUpload.effectiveDate" id="effectiveDate"
                (ngModelChange)="selectExpValue(documentDataForDocBulkUpload.effectiveDate)" />
              <span id="effectiveDate-required-msg" style="display: none; color: red;">Please choose effective
                date</span>
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="isShowExpDate">
          <div class="row">
            <div class="col-md-4">
              <label for="expirationDate">Expiration Date</label>
            </div>
            <div class="col-md-8">
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="documentDataForDocBulkUpload.expirationDate"
                [minDate]="documentDataForDocBulkUpload.effectiveDate" />
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4" *ngIf="isShowCheckBox">
        <div class="col-md-12">
          <mat-checkbox [(ngModel)]="isApplyToAll">
            Apply {{buttonLabel}} to all uploaded documents
          </mat-checkbox>
        </div>
      </div>

    </div>
    <div class="button-continer d-flex justify-content-end gap-3 mt-4 btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="okPublishFunc()">
        {{ buttonLabel }}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelPublishFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #publishConfirmPopup>
  <h2 mat-dialog-title>Confirm Publish</h2>
  <div style="margin: 15px 15px">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">Do you still wish to proceed with publishing this document?</div>
      </div>
      <br />
    </div>
    <div class="button-continer d-flex justify-content-end gap-3 mt-4 btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="confirmPublishWarningFunc()">
        Publish
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelConfirmPublishFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #bulkResultPopup>
  <div mat-dialog-title>
    <label for="pop" class="popupTitle">Bulk Operation Results</label>
  </div>
  <div style="margin: 15px;">
    <div class="table-container" style="max-height: 400px; overflow-y: auto;">
      <table class="search-manager-table-container" style="width: 60%;">
        <thead>
          <tr>
            <th style="text-align: left; padding: 10px;">Document Name</th>
            <th style="text-align: left; padding: 10px;">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr class="data-row-container" *ngFor="let res of bulkOperationResults">
            <td class="row-data" style="padding: 10px;">{{ res.documentName }}</td>
            <td class="row-data" style="padding: 10px;"
              [ngStyle]="{'color': res.isSuccess ? 'green' : 'red', 'font-weight': 'bold'}">
              {{ res.status }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="button-continer d-flex justify-content-center gap-3 mt-4 btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="closeBulkResultPopup()">
        OK
      </button>
    </div>
  </div>
</ng-template>